
import { AuthLayout, ResetEmail } from "modules/Authentication/components"

type Props = {};

const ResetEmailContainer = (props: Props) => {


    return (
        <AuthLayout>

            <ResetEmail

            />

        </AuthLayout>
    );
};

export default ResetEmailContainer;
